<template>
  <v-dialog
    v-model="display"
    persistent
    max-width="600px"
    scrollable
    v-if="display"
  >
    <v-card min-height="200px">
      <v-card-title>
        <div class="headline">
          Avis du CROP
        </div>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="text-subtitle-2">Avis:</span>&nbsp;
            {{ avis.avis ? "Favorable" : "Défavorable" }}
          </v-col>
          <v-col
            ><span class="text-subtitle-2">Date:</span>&nbsp;{{
              getDate(avis.date)
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="text-subtitle-2">Critère de moralité:</span>&nbsp;
            {{ avis.critereMoralite ? "Oui" : "Non" }}
          </v-col>
          <v-col
            ><span class="text-subtitle-2">DPC Validée:</span>&nbsp;
            {{ avis.dpcValidee ? "Oui" : "Non" }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="text-subtitle-2">Commentaire:</span>&nbsp;
            {{ avis.commentaire ? avis.commentaire : "Pas de commentaire" }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          class="white--text"
          @click="displayed = false"
          color="primary"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import common from "@/common";

export default {
  name: "ModalVoirAvisCROP",
  props: ["avis", "display"],
  computed: {
    displayed: {
      get() {
        return this.display;
      },
      set(value) {
        this.$emit("update:display", value);
      }
    }
  },
  methods: {
    getDate(timestamp) {
      return common.formatDate(timestamp);
    }
  }
};
</script>
